import { ButtonValueSelect } from "./ButtonValueSelect";
export function PassFailSelect(props) {
	let { skippable, resolvable, saveAction, onChange, ...passableProps } = props;
	let options = [
		["Pass", "PASS", "success", "secondary"],
		["Fail", "FAIL", "danger", "secondary"]
	];
	if(resolvable) {
		options.push(["Resolved", "RESOLVED", "info", "secondary"]);
	}
	if(skippable) {
		options.push(["N/A", "NA", "warning", "secondary"]);
	}
	return <ButtonValueSelect  options={options} saveAction={saveAction} onChange={onChange} {...passableProps} />
}